module.exports = "<div class=\"sv-action-bar-separator\" data-bind=\"css: $data.css\"></div>";


//////////////////
// WEBPACK FOOTER
// ./src/knockout/components/action-bar/action-bar-separator.html
// module id = 111
// module chunks = 0